/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 3/8/2021
 * @Example
 */

import React, { useEffect, useState } from 'react';
import { Dropdown, Button, Modal, ModalHeader, ModalBody } from 'diginet-core-ui/components';
import Config from '../../../../config/index';
import { useDispatch } from 'react-redux';
import * as W05F0008Actions from '../../../../redux/W0X/W05F0008/W05F0008_actions';

const ModalApproveW05F0008 = (props) => {
    const { onClose, itemApprove } = props;
    const dispatch = useDispatch();
    const [IsApprove, setIsApprove] = useState('');
    const [error, setError] = useState(false);
    const [cbApprove, setCbApprove] = useState([]);

    useEffect(() => {
        getCbApprove();
        /* eslint-disable */
    }, [])

    const getCbApprove = () => {
        dispatch(W05F0008Actions.getCbApprove({ Language: Config.language || 84 }, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            }
            setCbApprove(data);
        }))
    }

    const onSave = () => {
        if (!IsApprove) {
            setError(true);
            return false;
        }
        const params = {
            Language: Config.language || 84,
            ContractID: itemApprove.ContractID,
            SubContractID: itemApprove.SubContractID,
            IsApprove: IsApprove,
        };
        onApproval(params);
    }

    const onApproval = (params) => {
        dispatch(W05F0008Actions.onApproval(params, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            }
            if (data.Status !== 0) {
                Config.popup.show("INFO", data.Message);
                return false;
            }
            Config.notify.show("success", data.Message, 2000);
            const dataHistory = [];
            dataHistory.push({
                codeID: itemApprove.SubContractID,
                formID: "W05F0008",
                action: 1,
                oldValue: itemApprove.IsApproveName,
                newValue: data.newValue,
                description84: Config.lang('Trang_thai_Phu_luc_hop_dong', 'vi') + ' ' + itemApprove.SubContractNo,
                description01: Config.lang('Trang_thai_Phu_luc_hop_dong', 'en') + ' ' + itemApprove.SubContractNo,
                hasURL: false
            });
            Config.saveHistory({ attributes: JSON.stringify(dataHistory) });
            onClose();
        }));
    };

    return (
        <div>
            <Modal
                open={true}
                onClose={onClose}
                width={'50%'}
            >
                <ModalHeader title={Config.lang("Cap_nhat_trang_thai_duyet_phu_luc")} />
                <ModalBody>
                    <Dropdown
                        label={Config.lang("Chon_trang_thai_duyet")}
                        dataSource={cbApprove}
                        onChange={e => {
                            setIsApprove(e.value);
                            setError(false);
                        }}
                        valueExpr={"IsApprove"}
                        displayExpr={"IsApproveName"}
                        required
                        error={error}
                        value={IsApprove}
                        viewType="outlined"
                    />
                    <div className="pull-right">
                        <Button viewType="filled" color='info' label={Config.lang("Dong_y")} onClick={onSave} />
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default ModalApproveW05F0008;